import { get } from "lodash";
export default function getErrorValues(networkError) {
    var values = get(networkError, "errorData", {}) || {};
    var errorCode = get(networkError, "errorCode");
    values.errorCode = errorCode ? "(Code: " + errorCode + ")" : "";
    return values;
}
